import { Component, Suspense } from 'react';
import { useLocation } from 'react-router-dom';

class PageErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (this.state.failed) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center gap-4 p-6" role="alert">
          <p>Unable to load this page. Please reload and try again.</p>
          <button
            type="button"
            className="bg-primary text-primary-foreground px-4 py-2 text-sm font-medium"
            onClick={() => window.location.reload()}
          >
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function PageLoadingBoundary({ children }) {
  const { pathname } = useLocation();
  return (
    <PageErrorBoundary key={pathname}>
      <Suspense fallback={
        <div className="min-h-screen flex items-center justify-center text-muted-foreground" role="status">
          Loading page…
        </div>
      }>
        {children}
      </Suspense>
    </PageErrorBoundary>
  );
}
